import { IDeviceRepository } from "../../adapters/driven/repositories/deviceRepository";

export const DeviceServiceImplFactory = ({
  deviceRepository,
}: {
  deviceRepository: IDeviceRepository;
}) => {
  const getDeviceConnectionStatus: IGetDeviceConnectionStatus = async ({
    deviceId,
  }) => {
    try {
      const data = await deviceRepository.getDeviceConnectionStatusAPI({
        device_id: deviceId,
      });
      return { success: true, data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const verifyDevice: IVerifyDevice = async ({
    deviceId,
    proof,
    deviceDbId,
    inventoryId,
  }) => {
    try {
      const data = await deviceRepository.verifyDeviceAPI({
        device_id: deviceId,
        proof,
        ...(deviceDbId !== undefined ? { device_db_id: deviceDbId } : {}),
        ...(inventoryId !== undefined ? { inventory_id: inventoryId } : {}),
      });
      return { success: true, data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const registerDevice: IRegisterDevice = async ({ clinicId, deviceId }) => {
    try {
      const result = await deviceRepository.registerDeviceAPI({
        clinic_id: clinicId,
        device_id: deviceId,
      });
      return { success: true, data: result.data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getDeviceConnectionStatus,
    verifyDevice,
    registerDevice,
  };
};
